exports.categories = {
  'problem-list-item': {
    code: 'problem-list-item',
    display: 'Problem List Item',
    system: 'bcm',
    version: '1.0.0',
  },
  'encounter-diagnosis': {
    code: 'encounter-diagnosis',
    display: 'Encounter Diagnosis',
    system: 'bcm',
    version: '1.0.0',
  },
};